import type { CSSProperties } from 'react'
import { cn } from 'cn'
import { Lens, StepNode } from '@/components/site/brand-marks'
import type { ServiceStage } from '@/lib/services'

/**
 * Stages as one progression on a track (New Business): left to right on
 * wide screens, top to bottom below that. Every line stays visible. The
 * last labelled line ("Done when") is the stage's finish line and sits in
 * a tinted panel that lines up across the columns.
 */
export function ServiceStages({ stages }: { stages: ServiceStage[] }) {
  return (
    <ol className="svc-stages svc-stages--track">
      {stages.map((stage, index) => {
        const rows = 2 + (stage.body ? 1 : 0) + stage.lines.length
        return (
          <li
            key={stage.number}
            className="svc-stage"
            style={{ '--stage-rows': rows, '--stage-lines': stage.lines.length } as CSSProperties}
          >
            <StepNode index={index} count={stages.length} />
            <div className="svc-stage-head">
              <span className="svc-card-index">{stage.number}</span>
              <h3>{stage.title}</h3>
            </div>
            {stage.body ? <p>{stage.body}</p> : null}
            <StageLines lines={stage.lines} />
          </li>
        )
      })}
    </ol>
  )
}

/** Labelled lines; the last one is the "Done when" panel. */
export function StageLines({ lines }: { lines: ServiceStage['lines'] }) {
  return (
    <dl className="svc-stage-lines">
      {lines.map((line, index) => {
        const done = index === lines.length - 1
        return (
          <div key={line.label} className={cn(done && 'svc-stage-done')}>
            <dt>
              {done ? <Lens /> : null}
              {line.label}
            </dt>
            <dd>{line.text}</dd>
          </div>
        )
      })}
    </dl>
  )
}
